import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, objectSpread2 as _objectSpread2, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, Bounce } from 'react-toastify';
import classNames from 'classnames';
import { cssClassPrefix } from '../../../shared/constants/generalConstants.js';

var BASE_CSS = "".concat(cssClassPrefix, "-toast-container");
var AUTO_CLOSE_TIMEOUT = 5000; // time in ms
var IlToastContainer = /*#__PURE__*/function (_Component) {
  function IlToastContainer(props) {
    var _this;
    _classCallCheck(this, IlToastContainer);
    _this = _callSuper(this, IlToastContainer, [props]);
    _this.toastWrapperRef = /*#__PURE__*/React__default.createRef();
    _this.startTimer = _this.startTimer.bind(_this);
    _this.closeToastOnAnyClick = _this.closeToastOnAnyClick.bind(_this);
    _this.closeToast = _this.closeToast.bind(_this);
    return _this;
  }
  _inherits(IlToastContainer, _Component);
  return _createClass(IlToastContainer, [{
    key: "startTimer",
    value:
    // In order to satisfy WCAG accessibility requirements for timing,
    // rather than simply closing the notification after a delay,
    // first wait for the delay,
    // and then close the notification on the next user click of anything
    function startTimer(event) {
      var animationInNamePrefix = 'Toastify__bounceIn';
      if (event.animationName.match(animationInNamePrefix)) {
        setTimeout(this.closeToastOnAnyClick, this.minimumTimeToShow);
      }
    }
  }, {
    key: "closeToastOnAnyClick",
    value: function closeToastOnAnyClick() {
      document.body.addEventListener('click', this.closeToast);
    }
  }, {
    key: "closeToast",
    value: function closeToast() {
      var toastWrapper = this.toastWrapperRef.current;
      var closeButtonSelector = '.bx--toast-notification__close-button, .bx--inline-notification__close-button';
      var closeButton = toastWrapper && toastWrapper.querySelector(closeButtonSelector);
      if (closeButton) {
        closeButton.click();
        document.body.removeEventListener('click', this.closeToast);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var props = _objectSpread2({}, this.props);

      // The Toastify ToastContainer autoClose prop
      // accepts either a number for the number of milliseconds before closing
      // or false if the notification should not close automatically.
      // Store the number for our own auto-close logic and set the value to false.
      this.minimumTimeToShow = props.autoClose;
      props.autoClose = false;
      return /*#__PURE__*/React__default.createElement("div", {
        ref: this.toastWrapperRef,
        onAnimationStart: this.startTimer
      }, /*#__PURE__*/React__default.createElement(ToastContainer, _extends({}, props, {
        className: classNames(BASE_CSS, className)
      })));
    }
  }]);
}(Component);
_defineProperty(IlToastContainer, "propTypes", {
  position: PropTypes.oneOf(['top-right', 'top-center', 'top-left', 'bottom-right', 'bottom-center', 'bottom-left']),
  autoClose: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  closeButton: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  hideProgressBar: PropTypes.bool,
  pauseOnHover: PropTypes.bool,
  closeOnClick: PropTypes.bool,
  newestOnTop: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  toastClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  progressClassName: PropTypes.string,
  progressStyle: PropTypes.object,
  transition: PropTypes.func,
  rtl: PropTypes.bool,
  draggable: PropTypes.bool,
  draggablePercent: PropTypes.number,
  pauseOnFocusLoss: PropTypes.bool,
  enableMultiContainer: PropTypes.bool,
  containerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  role: PropTypes.string,
  onClick: PropTypes.func
});
_defineProperty(IlToastContainer, "defaultProps", {
  position: 'top-right',
  transition: Bounce,
  rtl: false,
  autoClose: AUTO_CLOSE_TIMEOUT,
  hideProgressBar: true,
  closeButton: false,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80,
  role: 'alert'
});

export { IlToastContainer as default };
